import { twMerge } from 'tailwind-merge';

import BookingIcon from '../../../assets/svg/BookingIcon';

export const RescheduledFilter = ({ isRescheduled, toggleIsRescheduled }) => {
  const onChange = () => {
    toggleIsRescheduled(prev => {
      return {
        ...prev,
        isRescheduled: !prev.isRescheduled,
      };
    });
  };

  return (
    <button
      className={twMerge(
        'flex items-center gap-2 rounded-full py-[11px] pl-5 pr-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
        isRescheduled && 'bg-brand-900 text-white',
      )}
      onClick={onChange}
    >
      <BookingIcon
        className={twMerge(
          'w-4 h-4 text-brand-500',
          isRescheduled && 'text-brand-300',
        )}
      />
      Rescheduled
    </button>
  );
};
